/** A successfully loaded value tied to the exact route/filter request that produced it. */
export interface KeyedLoadedValue<T> {
  readonly requestKey: string;
  readonly value: T;
}

export function marketSearchLoadKey(searchId: string | null): string {
  return JSON.stringify(['market-search', searchId]);
}

export function marketItemLoadKey(
  itemKey: string | null,
  completeness: string,
  includeAmbiguous: boolean,
): string {
  return JSON.stringify(['market-item', itemKey, completeness, includeAmbiguous]);
}

/**
 * Return loaded data only when it belongs to the current request.
 *
 * Keeping an older payload in React state is harmless: route or filter changes
 * make it non-renderable immediately, including when the replacement read fails.
 */
export function valueForRequestKey<T>(
  loaded: KeyedLoadedValue<T> | null,
  requestKey: string,
): T | null {
  return loaded?.requestKey === requestKey ? loaded.value : null;
}
